import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { Modal } from "src/Components";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import {
  ICustomerReportScopeSearchParams,
  ICustomerReportScopeTableReport,
} from "src/Interfaces/reportLinks";
import { getCustomerReportScopeTable } from "src/Requests/reportLinksRequests";
import { Additional } from "./Additional";
import SearchParamBox from "./SearchParamBox";
import UpsertModal from "./UpsertModal";

enum ModalMode {
  Closed,
  Add,
}

const ReportLinks: React.FC = () => {
  const [modalMode, setModalMode] = React.useState(ModalMode.Closed);
  const [refreshFlag, setRefreshFlag] = React.useState(false);
  const [searchParam, setSearchParam] =
    React.useState<ICustomerReportScopeSearchParams>({
      accountId: null,
    });
  const [serverSearchParams, setServerSearchParams] =
    React.useState<ICustomerReportScopeSearchParams>({
      accountId: null,
    });

  const searchParamChangeHandler = (name: string, value: any) => {
    const nextSearchParam = {
      ...searchParam,
      [name]: value,
    };
    setSearchParam(nextSearchParam);
    setServerSearchParams(nextSearchParam);
  };

  return (
    <>
      {modalMode === ModalMode.Add ? (
        <Modal
          title="افزودن لینک گزارش"
          UI={
            <UpsertModal
              onClose={() => setModalMode(ModalMode.Closed)}
              onSuccess={() => setRefreshFlag(true)}
            />
          }
          onClose={() => setModalMode(ModalMode.Closed)}
          modalBoxClassName="!min-w-[360px] z-[99999]"
        />
      ) : null}
      <div className="flex flex-col gap-4 w-full px-4 mt-8">
        <div className="flex flex-row justify-between items-center w-full">
          <SearchParamBox
            searchParam={searchParam}
            onChange={searchParamChangeHandler}
          />
          <div
            className="bg-sky-600 rounded-full flex justify-center items-center w-11 h-11 cursor-pointer"
            onClick={(e) => {
              setModalMode(ModalMode.Add);
              e.stopPropagation();
            }}
          >
            <AddIcon className="text-white" data-testid="add-button" />
          </div>
        </div>
        <TableTemplate<
          ICustomerReportScopeSearchParams,
          ICustomerReportScopeTableReport
        >
          TableUI={({ reports, onAction, sortingType, setSortingType }) => (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              refreshFlag={refreshFlag}
              AdditionalBody={Additional}
              sortingType={sortingType}
              setSortingType={setSortingType}
            />
          )}
          getDataTable={getCustomerReportScopeTable}
          searchParameters={serverSearchParams}
          withSort
        />
      </div>
    </>
  );
};

export default ReportLinks;
